import React, {Component} from "react"
import {Button, Icon} from "semantic-ui-react"
import {Link} from "react-router-dom"
import classNames from "classnames"
import "./SubmitPage.css"
import {withTranslation} from 'react-i18next'

class SubmitPage extends Component {

    constructor(props) {
        super(props)
        this.state = {
            count: 0, phase: "phase-setup"
        }
    }

    timer() {
        this.setState({
            count: Math.min(100, this.state.count + 2)
        })

        if (this.state.count > 99) {
            clearInterval(this.intervalId);
            this.setState({
                phase: "phase-one"
            })
            setTimeout(() => {
                this.setState({phase: "phase-two"})
            }, 900)
        }
    }

    componentDidMount() {
        setTimeout(() => {
            this.intervalId = setInterval(this.timer.bind(this), 16);
            this.setState({
                phase: "phase-zero"
            })
        }, 800)
    }

    componentWillUnmount() {
        clearInterval(this.intervalId);
    }

    render() {
        let count = this.state.count
        if (count) count += "%"
        let phase = this.state.phase
        const { t } = this.props;

        // let order = api.getOrder()
        return (
            <div className="transition-item submit-page">
                <div className="animation-container">
                    <div className={classNames("tc", phase)}>
                        <div className="world-center loader-bg box-50 animated shrink "/>
                        <div className="world-center checkmark box-50 stacked fade-in-big">
                            <Icon className="white" name="checkmark"/>
                        </div>
                        <div className="world-center counter text-below  stacked">{count ? count : null}</div>
                        <div className="world-center description stacked text-below white ">
                            <span className="animated fade-in dib pb2">{t("job.sent")}</span>
                            {phase === "phase-two" ? <div className="animated fade-in delay-500">
                                <Link to="/summary"><Button color="green">{t("report.final.show")}</Button></Link>
                            </div> : null}
                        </div>
                        <div
                            className="world-center line stacked animated slide-down quick"/>
                        {/*<div className="world-center paper-bg  stacked morph-to-document">*/}
                        {/*/!*<div className="tl  phase-two-fade-in">*!/*/}
                        {/*/!*<OrderSummary order={order} />*!/*/}
                        {/*/!*</div>*!/*/}
                        {/*</div>*/}
                    </div>
                </div>
            </div>
        )
    }
}

export default withTranslation()(SubmitPage)



// WEBPACK FOOTER //
// ./src/pages/SubmitPage.js